import { render } from "./LabelTask.vue?vue&type=template&id=b8fb30f2"
import script from "./LabelTask.vue?vue&type=script&lang=js"
export * from "./LabelTask.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__